import { render, staticRenderFns } from "./TariffResult.vue?vue&type=template&id=0abc36f4&"
import script from "./TariffResult.vue?vue&type=script&lang=ts&"
export * from "./TariffResult.vue?vue&type=script&lang=ts&"
import style0 from "./TariffResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports